{
  "maximum": "Massimo",
  "minimum": "Minimo"
}
